'use strict';
/*
 * A filter to trust a resource URL. This simply exposes $sce.trustAsResourceUrl as a filter,
 * causing whatever unsafe URL to become a trusted URL
 */

angular.module('msUtility').filter('trustedUrl', ['$sce', function ($sce) {
  return $sce.trustAsResourceUrl;
}]);